import { SET_THEME } from '../actionTypes';
import { profileActions } from '../reducer';

export default (value) => (dispatch) => {
    dispatch(profileActions[SET_THEME](value));
    localStorage.setItem('theme', value);
};
